import {NotificationService} from "../services/NotificationService";
import {ApplicationSettingService} from "../services/ApplicationSettingService";
import {FixedVTagService} from "../services/FixedVTagService";
import {FixedVTag} from "../entities/FixedVTag";
import {IVTag} from "../entities/IVTag";
import {CommandBase} from "./CommandBase";
import {CommandManager} from "../libs/CommandManager";

export class CommandSetPositionFixedDirective extends CommandBase implements ng.IDirective {
    restrict= 'AEC';
    transclude = false;
    template = require('../../views/cmdsetpositionfixed.html').default;
    scope = {
        map : "=",
        ppm : "=",
        mapArea : "=",
        selectedItems : "=",
        commandEnabled : "=",
    };
    tempFixedTag:FixedVTag;
    vTagPositionReportingMode: string = "EXACT";
    allowFixedTagsDiffMap: boolean = true;
    constructor(public modal:angular.ui.bootstrap.IModalService,
                public fixedTagService:FixedVTagService,
                public applicationSettingService:ApplicationSettingService,
                public notificationService:NotificationService,
                commandManager:CommandManager) {
        super(commandManager);
    }
    controller = ['$scope',($scope:any)=>{
        this.applicationSettingService.getCached().then((data)=>{
            this.vTagPositionReportingMode = data.vTagPositionReportingMode;
            this.allowFixedTagsDiffMap = data.fixedTagsMoveToDiffMap;
        });
        $scope.$watch(()=>$scope.map, (newVal:any)=> {
            //do something with the new Time
            //console.log("got new map");
        });
        $scope.$watch(()=>$scope.commandEnabled, (newVal:any)=> {
        });
        $scope.$watch(()=>$scope.selectedItems.length, (newVal:any)=> {
            this.selectedItems = $scope.selectedItems;
        });
        $scope.$on('leafletDirectiveMap.mainMap.click', (map:any,evt:any)=>{
            //open up dialog and do stuff
            var mapX = evt.leafletEvent.latlng.lng;
            var mapY = evt.leafletEvent.latlng.lat;
            var xMeters = mapX / parseFloat($scope.ppm);
            var yMeters = mapY / parseFloat($scope.ppm);
            if($scope.commandEnabled) {
                console.log("got click from super map. put up DIALOG ETC "+(this.modal==null));
                var modalInstance:angular.ui.bootstrap.IModalServiceInstance = this.modal.open({
                    animation: true,
                    //size: 'sm',
                    template: require('../../views/cmdsetpositionfixeddialog.html').default,
                    controller: 'CmdCenterSetPositionFixedCtrl',
                    resolve: {
                        vtagX: function () {
                            return xMeters;
                        },
                        vtagY: function () {
                            return yMeters;
                        },
                        vtagZ: function(){
                            return $scope.mapArea.floorLevel;
                        }
                    }
                });
                modalInstance.result.then((memFixedTag:FixedVTag)=>{
                    this.tempFixedTag = new FixedVTag(null, memFixedTag.name, memFixedTag.vTagID, memFixedTag.vTagX, memFixedTag.vTagY, memFixedTag.vTagZ, memFixedTag.locationID);
                    this.tempFixedTag.readerID = memFixedTag.readerID;
                    this.tempFixedTag.vTagType = memFixedTag.vTagType;
                    this.fixedTagService.getFirstVTagMatch(memFixedTag.vTagID).then((fixedTag)=>{
                      if(fixedTag == null){
                        if(!memFixedTag.isGPSTag() && this.vTagPositionReportingMode != "EXACT"){
                          memFixedTag.vTagX = null;
                          memFixedTag.vTagY = null;
                          memFixedTag.vTagZ = null;
                        }
                        else
                          memFixedTag.vTagLastSeen = new Date().toUTCString();
                        this.fixedTagService.insert(memFixedTag).then(()=>{
                          if(!memFixedTag.isGPSTag() && this.vTagPositionReportingMode != "EXACT"){
                            this.runCommand();
                          }
                          else
                            this.notificationService.notify("Tag coordinates have been saved.")
                        })
                          .catch((err:any)=>{
                            this.notificationService.notifyError("Got error in saving data:"+err);
                          });
                      }
                      else {
                        fixedTag.name = memFixedTag.name;
                          fixedTag.locationID = memFixedTag.locationID;
                          this.tempFixedTag.readerID = fixedTag.readerID;
                            var offsetMode: boolean = !fixedTag.isGPSTag() && this.vTagPositionReportingMode != "EXACT";
                            if (!offsetMode && !this.allowFixedTagsDiffMap && fixedTag.vTagZ != null && fixedTag.vTagZ != memFixedTag.vTagZ) {
                              //this fixed tag 
                              this.notificationService.notify("Fixed Tag already belongs to different map. Enable this feature in Admin Tools->Options.");
                              return
                          }
                          if (fixedTag.isGPSTag() || this.vTagPositionReportingMode == "EXACT") {
                              //for OFFSET, don't set XYZ until get command Ack
                              fixedTag.vTagX = memFixedTag.vTagX;
                              fixedTag.vTagY = memFixedTag.vTagY;
                              fixedTag.vTagZ = memFixedTag.vTagZ;
                              fixedTag.vTagLastSeen = new Date().toUTCString();
                          }                          
                          this.fixedTagService.update(fixedTag).then(() => {
                              if (offsetMode) {
                            this.runCommand();
                          }
                          else
                            this.notificationService.notify("Tag coordinates have been saved.")
                        })
                          .catch((err:any)=>{
                            this.notificationService.notifyError("Got error in saving data:"+err);
                          });
                      }
                    });
                })
            }
            else if (false){
            }
        });
    }]
    getItems(){
        return [this.tempFixedTag];
    }
    getCommandText(tag:IVTag):string{
        return tag.vTagID + ":" + tag.vTagX + ":"+ tag.vTagY + ":" + tag.vTagZ + ":" + "Fixed" + ":" + tag.locationID;
    }
    getCommandType():string{
        return "Set Position";
    }
    static factory():ng.IDirectiveFactory {
        var directive = (modal:angular.ui.bootstrap.IModalService,
                         commandManager:CommandManager,
                         fixedTagService:FixedVTagService,
                         applicationSettingService:ApplicationSettingService,
                         notificationService:NotificationService) => {
            return new CommandSetPositionFixedDirective(modal,fixedTagService,applicationSettingService,notificationService,commandManager);
        }
        directive.$inject = ['$uibModal','CommandManager','FixedVTagService','ApplicationSettingService','NotificationService'];
        return directive;
    }
}
